<template>
  <TabContainer>
    <TabInner name="First">
      abc
    </TabInner>
    <DemoTabComponent>
      def
    </DemoTabComponent>
    <products:ThirdTab />
  </TabContainer>
</template>
